/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectPlusIcon20Light = forwardRef('CommentRectPlusIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 7a.5.5 0 0 0-1 0v2H7a.5.5 0 0 0 0 1h2v2a.5.5 0 0 0 1 0v-2h2a.5.5 0 0 0 0-1h-2V7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 3a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3v2.04a1 1 0 0 0 1.573.819L10.658 15H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3H5ZM3 6a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3.5a.5.5 0 0 0-.287.09L6 17.04V14.5a.5.5 0 0 0-.5-.5H5a2 2 0 0 1-2-2V6Z" })));
});
